import React, { useContext, useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import {
  CREATE_PAYPHONE_TRANSACTION_ENDPOINT,
  GET_BUSINESS_BY_EMAIL,
  GET_PLAN_BY_UUID_ENDPOINT,
  LOGIN_PRACTIDAY_ENDPOINT,
  REGISTRO_PRACTIDAY_ENDPOINT,
} from "../helpers/endpoints";
import PlanDetail from "../components/PlanDetail";
import CardBusinessInfo from "../components/CardBusinessInfo";
import { token } from "../helpers/security.js";
import { v4 as uuidv4 } from "uuid";
import PurchasePlaceholder from "./PurchasePlaceholder.jsx";
import {
  PurchaseContext,
  isValidBusinessId,
} from "../context/PurchaseContext.jsx";

const Purchase = () => {
  let { planUuid, businessId } = useParams();
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [errorDescription, setErrorDescription] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertRegister, setShowAlertRegister] = useState(false);
  const [showPayphoneActions, setShowPayphoneActions] = useState(false);
  const [showSuccessfulPayment, setShowSuccessfulPayment] = useState(false);
  const [showUnsuccessfulPayment, setShowUnsuccessfulPayment] = useState(false);
  const { business, setBusiness, fetchBusiness } = useContext(PurchaseContext);
  const [currentClientTransactionId, setCurrentClientTransactionId] =
    useState(null);

  useEffect(() => {
    if (planUuid) {
      getPlanByUuid(planUuid);
    }
    // Llegada directa desde pd-web (/business/:businessId/purchase/:planUuid)
    if (!business && isValidBusinessId(businessId)) {
      fetchBusiness(businessId);
    }
  }, []);

  useEffect(() => {
    if (plan && business) {
      hidePayphoneButton();
      createPayphoneTransaction(business);
    }
  }, [plan, business]);

  const getPlanByUuid = async (uuid) => {
    fetch(GET_PLAN_BY_UUID_ENDPOINT + `/${uuid}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setPlan(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    clearAlerts();

    if (email === "") {
      setShowAlert(true);
      setErrorDescription("El correo electrónico es obligatorio");
      return;
    }

    fetch(GET_BUSINESS_BY_EMAIL + `/${email}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            setBusiness(data);
          });
        } else {
          setShowAlertRegister(true);
          hidePayphoneButton();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const hidePayphoneButton = () => {
    let ppButton = document.getElementById("pp-button");
    if (ppButton) {
      while (ppButton.firstChild) {
        ppButton.removeChild(ppButton.firstChild);
      }
      ppButton.style.display = "none";
    }
  };

  const createPayphoneTransaction = async (business) => {
    if (business === null || plan === null) {
      clearAlerts();
      setShowAlert(true);
      setErrorDescription("No se pudo crear la transacción");
      return;
    }

    const clientTransactionId = uuidv4();
    setCurrentClientTransactionId(clientTransactionId);

    fetch(CREATE_PAYPHONE_TRANSACTION_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
      body: JSON.stringify({
        clientTransactionId: clientTransactionId,
        businessMail: business.correoEmpresarial,
        planVentaUuid: plan.uuid,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data === false) {
          clearAlerts();
          setShowAlert(true);
          setErrorDescription(
            "No se pudo crear la transacción, por favor intente más tarde"
          );
          return;
        } else {
          setShowPayphoneActions(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (showPayphoneActions) {
      deletePayphoneButton();
      showPayphoneButton(currentClientTransactionId);
      document.getElementById("pp-button").style.display = "block";
    }
  }, [showPayphoneActions]);
  const clearAlerts = () => {
    setShowAlert(false);
    setShowAlertRegister(false);
  };

  const showPayphoneButton = (clientTransactionId) => {
    let precio = parseInt(plan.precio * 100);
    window.payphone
      .Button({
        token,
        btnHorizontal: true,
        btnCard: true,

        createOrder: function (actions) {
          // Se ingresan los datos de la transaccion ej. monto, impuestos, etc
          return actions
            .prepare({
              amount: precio,
              amountWithoutTax: precio,
              currency: "USD",
              clientTransactionId,
            })
            .then(function (paramlog) {
              return paramlog;
            })
            .catch(function (paramlog2) {
              return paramlog2;
            });
        },
        onComplete: function (model, actions) {
          actions
            .confirm({
              id: model.id,
              clientTxId: model.clientTxId,
            })
            .then(function (value) {
              if (value.transactionStatus === "Approved") {
                setShowSuccessfulPayment(true);
              }
            })
            .catch(function (err) {
              if (err.includes("window closed")) {
                setShowUnsuccessfulPayment(true);
              }
              console.log(err);
              const error = JSON.parse(err);

              if (error.errorCode === 20) {
                createPayphoneTransaction(business);
              }
            });
        },
      })
      .render("#pp-button");
  };

  const deletePayphoneButton = () => {
    const botonPayphone = document.getElementById("pp-button");

    if (botonPayphone.lastElementChild) {
      botonPayphone.removeChild(botonPayphone.lastElementChild);
    }
  };

  const onChangeBusiness = () => {
    setBusiness(null);
    setShowPayphoneActions(false);
    setEmail("");
  };

  return (
    <Container fluid style={{ backgroundColor: "#ECECEC" }}>
      {loading ? (
        <PurchasePlaceholder />
      ) : (
        <>
          {plan ? (
            <Row className="p-3">
              <Col sm={12} md={6} lg={8}>
                <div>
                  <Alert
                    variant="danger"
                    onClose={() => setShowAlert(false)}
                    dismissible
                    show={showAlert}
                    className="mt-3 mb-3"
                  >
                    <b>{errorDescription}</b>
                  </Alert>

                  <Alert
                    variant="warning"
                    onClose={() => setShowAlertRegister(false)}
                    dismissible
                    show={showAlertRegister}
                    className="mt-3 mb-3"
                  >
                    El correo ingresado no esta registrado.
                    <br />
                    <Alert.Link
                      href={REGISTRO_PRACTIDAY_ENDPOINT}
                      target="_blank"
                    >
                      ¡Regístrese ahora!
                    </Alert.Link>
                  </Alert>

                  {showSuccessfulPayment ? (
                    <Card className="text-center">
                      <Card.Header>
                        <Card.Title className="text-primary">
                          ¡Pago exitoso!
                        </Card.Title>
                      </Card.Header>
                      <Card.Body>
                        <Card.Text>
                          Hemos completado tu pago y tu paquete se ha
                          acreditado.
                        </Card.Text>
                        <Card.Text>
                          Ahora puedes ingresar a Practiday para empezar a
                          disfrutarlo.
                        </Card.Text>
                        <a href={LOGIN_PRACTIDAY_ENDPOINT} target="_self">
                          <Button variant="dark" className="m-1">
                            Ir a Practiday
                          </Button>
                        </a>
                      </Card.Body>
                    </Card>
                  ) : showUnsuccessfulPayment ? (
                    <Card className="text-center">
                      <Card.Header>
                        <Card.Title className="text-danger">
                          ¡No se pudo realizar el pago!
                        </Card.Title>
                      </Card.Header>
                      <Card.Body>
                        <Card.Text>
                          Lo sentimos, no pudimos procesar su pago en este
                          momento. Por favor, inténtelo de nuevo más tarde o
                          póngase en contacto con nuestro equipo de soporte si
                          el problema persiste.
                        </Card.Text>
                        <Button
                          variant="dark"
                          onClick={() => window.location.reload()}
                        >
                          Comprar otra vez
                        </Button>
                      </Card.Body>
                    </Card>
                  ) : showPayphoneActions ? (
                    <CardBusinessInfo
                      business={business}
                      planName={plan.nombre}
                      onChangeBusinessCallback={onChangeBusiness}
                    />
                  ) : (
                    <Form onSubmit={submitForm}>
                      <Form.Group>
                        <Form.Label>Ingrese su correo electrónico</Form.Label>
                        <Form.Control
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="name@example.com"
                        />
                        <Form.Text className="text-muted">
                          Correo registrado con su empresa en <b>Practiday</b>
                        </Form.Text>
                      </Form.Group>

                      <div className="mt-3 text-center">
                        <Button
                          variant="dark"
                          type="submit"
                          className="mt-2 mb-3"
                        >
                          Enviar
                        </Button>
                      </div>
                    </Form>
                  )}
                </div>
              </Col>

              <Col sm={0} md={6} lg={4} className="d-none d-sm-block">
                <PlanDetail
                  key={plan.id}
                  nombre={plan.nombre}
                  precio={plan.precio}
                  tipo={plan.tipoPlanVenta}
                  diasVigencia={plan.diasVigencia}
                  tag={plan.tag}
                  descripciones={plan.descripciones}
                  showBuyButton={false}
                />
              </Col>
            </Row>
          ) : (
            <p>No se encontraron resultados</p>
          )}
        </>
      )}
    </Container>
  );
};

export default Purchase;
